function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 13",
  fill: "none",
  d: "M0 0h24.744v42.483H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 11",
  fill: "#131b40",
  d: "M9.977 0h4.382v1.355H9.977z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36",
  d: "M9.803 6.943a11.791 11.791 0 01-6.714 5.223v1.087s4.539-1.111 6.714-4.8z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37",
  d: "M9.803 9.355a12.524 12.524 0 01-6.714 4.368l.118 1.046a10.285 10.285 0 001.495-.319l.03.614s-.4.079-1.428.232l.156.982a5.634 5.634 0 00.913-.047l.1.547-.894.047s1.19 5.154 2.443 6.336a11.588 11.588 0 015.06 1.253l-.308-2.979s-1.584-2.27-2.1-9.433l1.261-1.348z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38",
  d: "M10.025 11.537l-.849.757.124 1.1.838-.758z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 39",
  d: "M10.146 13.397l-.694.629a27.749 27.749 0 001.135 5.644s-.441-5.643-.441-6.273",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 40",
  d: "M6.714 23.831l.946 1.135a9.617 9.617 0 013.42 1.2V25a10.686 10.686 0 00-4.366-1.166",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41",
  d: "M8.511 25.786l.977 1.45h1.828s-.567-1.04-2.806-1.45",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 42",
  d: "M12.168 7.155h-1.7l1.261 20.08.441.41z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 43",
  d: "M4.666 25.282H0v-1.229h3.972z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 44",
  d: "M5.579 26.165l.867 1.072H0v-1.072z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 45",
  d: "M9.299 6.588H7.936s-1.561 3.493-6.519 4.09c0 0-.787 10.884 5.922 16.558h1.554l-.062-.056c-6.967-6.303-6.28-15.456-6.28-15.456a10.843 10.843 0 006.748-5.136",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 46",
  d: "M14.94 6.943a11.79 11.79 0 006.714 5.223v1.087s-4.539-1.111-6.714-4.8z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 47",
  d: "M14.941 9.355a12.524 12.524 0 006.714 4.368l-.118 1.046a10.289 10.289 0 01-1.495-.319l-.03.614s.4.079 1.428.232l-.156.982a5.634 5.634 0 01-.913-.047l-.1.547.894.047s-1.19 5.154-2.443 6.336a11.587 11.587 0 00-5.059 1.253l.307-2.979s1.584-2.27 2.1-9.433l-1.256-1.347z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 48",
  d: "M14.72 11.537l.849.757-.124 1.1-.838-.758z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 49",
  d: "M14.593 13.397l.694.629a27.749 27.749 0 01-1.135 5.644s.441-5.643.441-6.273",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 50",
  d: "M18.03 23.831l-.946 1.135a9.616 9.616 0 00-3.42 1.2V25a10.685 10.685 0 014.366-1.166",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 51",
  d: "M16.233 25.786l-.977 1.45h-1.829s.567-1.04 2.806-1.45",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 52",
  d: "M12.576 7.155h1.7l-1.261 20.08-.441.41z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 53",
  d: "M20.076 25.282h4.665v-1.229h-3.965z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 54",
  d: "M19.164 26.165l-.867 1.072h6.446v-1.072z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 55",
  d: "M15.445 6.588h1.363s1.561 3.493 6.519 4.09c0 0 .787 10.884-5.922 16.558h-1.558l.062-.056c6.971-6.303 6.282-15.456 6.282-15.456a10.843 10.843 0 01-6.748-5.136",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 56",
  d: "M13.886 5.264V1.702h-3.152v3.562H6.967v1.324h10.8V5.264zm-.768-.312h-1.69v-.52h1.69zm0-1.028h-1.69v-.52h1.69zm0-1.028h-1.69v-.52h1.69z",
  fill: "#131b40"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 12",
  fill: "#131b40",
  d: "M0 37.012h24.744v.946H0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 57",
  d: "M9.291 32.902h.851l-.473-2.459z",
  fill: "#43a8a8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 58",
  d: "M13.521 27.749l-1.044 1.85-.95-1.85H-.001v8.691h24.745v-8.691zM6.176 34.26a1.467 1.467 0 01-.415.54 1.756 1.756 0 01-.647.319 3.154 3.154 0 01-.835.1 4.458 4.458 0 01-1.055-.112 3.214 3.214 0 01-.671-.224l.351-.935a2.157 2.157 0 00.228.1 2.811 2.811 0 00.315.1 3.629 3.629 0 00.372.08 2.493 2.493 0 00.4.032 1.409 1.409 0 00.747-.164.55.55 0 00.26-.5.52.52 0 00-.188-.415 2.067 2.067 0 00-.472-.292q-.283-.132-.615-.272a3.153 3.153 0 01-.615-.344 1.752 1.752 0 01-.472-.507 1.452 1.452 0 01-.188-.775 1.7 1.7 0 01.136-.707 1.327 1.327 0 01.388-.5 1.665 1.665 0 01.6-.3 2.846 2.846 0 01.767-.1 4.826 4.826 0 01.919.084 2.341 2.341 0 01.711.244l-.344.919a1.927 1.927 0 00-.527-.2 3.006 3.006 0 00-.759-.092.972.972 0 00-.587.152.482.482 0 00-.2.408.5.5 0 00.188.4 2.156 2.156 0 00.472.3q.283.136.615.28a3.315 3.315 0 01.615.348 1.776 1.776 0 01.472.5 1.383 1.383 0 01.188.747 1.844 1.844 0 01-.148.771m4.341.724l-.158-1.1H9.13l-.252 1.1H7.869l1.166-5.422h1.482l1.292 5.422zm6.494-4.508h-1.7v1.355h1.182v.946h-1.12v2.317h-1.111v-5.532h2.742zm5.3 0h-1.689v1.229h1.135v.977h-1.135v1.513h1.679v.788H19.54v-5.422h2.766z",
  fill: "#43a8a8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 59",
  d: "M1.115 42.482a2.174 2.174 0 01-.513-.063 1.244 1.244 0 01-.406-.164l.054-.47a1.471 1.471 0 00.4.176 1.626 1.626 0 00.442.065.677.677 0 00.382-.091.294.294 0 00.135-.257.271.271 0 00-.113-.226 1.562 1.562 0 00-.429-.187 1.536 1.536 0 01-.635-.334.7.7 0 01-.19-.513.717.717 0 01.116-.406.767.767 0 01.339-.275 1.276 1.276 0 01.521-.1 1.805 1.805 0 01.431.054 1.523 1.523 0 01.384.147l-.076.456a1.532 1.532 0 00-.35-.146 1.373 1.373 0 00-.365-.058.6.6 0 00-.346.083.273.273 0 00-.117.237.267.267 0 00.045.16.386.386 0 00.147.113 2.28 2.28 0 00.293.111 1.775 1.775 0 01.693.354.693.693 0 01.2.519.713.713 0 01-.278.594 1.21 1.21 0 01-.763.217"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 60",
  d: "M3.215 39.697h.549v1.095h1.311v-1.095h.549v2.728h-.549v-1.181H3.764v1.181h-.549z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 61",
  d: "M6.796 39.697h1.8v.46H7.325v.653h1.124v.456H7.325v.7h1.321v.46h-1.85z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 62",
  d: "M9.724 39.697h.89a1.209 1.209 0 01.524.108.832.832 0 01.354.309.867.867 0 01.127.474.84.84 0 01-.275.659 1.06 1.06 0 01-.734.246h-.356v.933h-.531zm.531 1.353h.281a.625.625 0 00.411-.118.419.419 0 00.142-.341.411.411 0 00-.14-.338.637.637 0 00-.413-.115h-.284z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 63",
  d: "M12.591 39.697h.549v1.095h1.31v-1.095h.549v2.728h-.549v-1.181h-1.31v1.181h-.549z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 64",
  d: "M16.172 39.697h1.8v.46h-1.269v.653h1.127v.456h-1.127v.7h1.321v.46h-1.852z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 65",
  d: "M19.101 39.697h.887a1.1 1.1 0 01.739.231.8.8 0 01.269.637.808.808 0 01-.118.433.876.876 0 01-.338.311l.729 1.116h-.617l-.585-.98-.1.006h-.339v.973h-.524zm.524 1.314h.269q.563 0 .564-.442a.386.386 0 00-.138-.321.647.647 0 00-.408-.109h-.287z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 66",
  d: "M22.202 39.697h1.045a1.583 1.583 0 011.1.357 1.47 1.47 0 01-.011 2.012 1.648 1.648 0 01-1.133.359h-1.005zm.546 2.287h.449q.98 0 .98-.923t-.977-.923h-.452z"
})));

var SvgSsLogo = function SvgSsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 581",
    viewBox: "0 0 24.744 42.482",
    width: 60,
    height: 60,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ss-logo.a45d3366.svg";
export { ForwardRef as ReactComponent };